import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import {
  Avatar,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Backdrop,
  CircularProgress,
} from "@mui/material"
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined"
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined"

import useStylesDetails from "./useStylesDetails"
import { NavLink } from "react-router-dom"
import { useState } from "react"
import { useDispatch } from "react-redux"
import {
  deleteCustomerUser,
  getAllTypesUser,
  updateUserOrganization,
  updateUserStatusLoginAccount,
} from "../../../redux/actions/User"
import { getUserStatusCorpEntities } from "../../../app/services/Organization/getUserStatusCorpEntities"
import { getLoginAccountStatusCorpEntities } from "../../../app/services/LoginAccount/getLoginAccountStatus"
// import { ModalSeeMoreTel } from '../Modals/ModalSeeMoreTel'
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"
import ModalConfirmChange from "../../../components/Modals/Organizations/User/ModalConfirmChange/ModalConfirmChange"

import { helpGetUserLoginAccountWithEmail } from "../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail"
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined"
import { getUserOrganizationByLoginAccountCorpEntities } from "../../../app/services/Organization/getUserOrganizationByLoginAccountCorpEntities"
import { getSubscriberUserCorpEntities } from "../../../app/services/Suscriber/getSubscriberUserCorpEntities"
import { getTraducTypeUser } from "../../../utils/UserTools"

export default function StepperDetailsUser({
  setStateUserDetails,
  user,
  countSubscribersAsociate,
}) {
  const classes = useStylesDetails()
  const dispatch = useDispatch()
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }
  const [loading, setLoading] = useState(false)
  const [userData, setuserData] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState(
    user.state?.userStatusCode ?? "",
  )
  const [statesUserOrg, setStatesUserOrg] = useState([])
  const [selectedStatusLoginAccount, setSelectedStatusLoginAccount] = useState(
    user?.accountStatus?.accountStatusCode ?? "",
  )
  const [statesUser, setStatesUser] = useState([])
  const [isModalOpenTypeUser, setisModalOpenTypeUser] = useState(false)
  const [isModalOpenStatusAccount, setisModalOpenStatusAccount] =
    useState(false)
  const [isModalOpenStatusUserOrg, setisModalOpenStatusUserOrg] =
    useState(false)
  const [selectedType, setSelectedType] = useState(
    user.type?.organizationUserTypeCode ?? "",
  )
  const [typesUser, settypesUser] = useState([])
  const [userDataForChanges, setUserDataForChanges] = useState("")
  const handleOpenModalType = (value) => {
    setSelectedType(value)
    setisModalOpenTypeUser(true)
  }
  const getUserOrgStatus = async () => {
    try {
      const status = await getUserStatusCorpEntities()
      setStatesUserOrg(status.data?.data)
    } catch (error) {
      console.log(error)
    }
  }
  const getUserStatus = async () => {
    try {
      const status = await getLoginAccountStatusCorpEntities()

      setStatesUser(status.data?.data)
    } catch (error) {
      console.log(error)
    }
  }
  const getAllTypes = async () => {
    try {
      const types = await dispatch(getAllTypesUser())

      settypesUser(types)
    } catch (error) {
      console.log(error)
    }
  }
  const currentUserTypeCode =
    userDataForChanges?.[0]?.type?.organizationUserTypeCode || ""

  const currentUserOrgStatusCode =
    userDataForChanges?.[0]?.status?.userStatusCode || ""

  const currentUserStatusCode = userData?.accountStatus?.accountStatusCode || ""

  const handleOpenModalChangeStatus = (value, type) => {
    type === "login_account"
      ? setSelectedStatusLoginAccount(value)
      : setSelectedStatus(value)
    type === "login_account"
      ? setisModalOpenStatusAccount(true)
      : setisModalOpenStatusUserOrg(true)
  }

  const getSubscriber = async () => {
    try {
      const userId = userDataForChanges?.[0]?.userId
      const response = await getSubscriberUserCorpEntities(userId)
      return {
        subscriberRefId: response?.data?.[0].subscriber_ref_id,
        organizationId: response?.data?.[0].organization_id,
      }
    } catch (error) {
      return 0
    }
  }

  const handleChangeStatusUser = async () => {
    const updateStatus = await dispatch(
      updateUserOrganization({
        organizationUserId: userDataForChanges?.[0]?.userId,
        userStatusCode: selectedStatus,
      }),
    )

    if (Number(updateStatus?.userStatusId)) {
      await userDataChanges()
      const getByStatusId = statesUserOrg.find(
        (option) => option.userStatusId === Number(updateStatus.userStatusId),
      )
      const status = {
        userStatusCode: getByStatusId.userStatusCode,
        userStatusName: getByStatusId.userStatusName,
      }

      if (selectedStatus === "DELETED") {
        try {
          const subscriberData = await getSubscriber()
          if (subscriberData) {
            const deleteResult = await dispatch(
              deleteCustomerUser({
                clicod: subscriberData.subscriberRefId,
                organizationId: subscriberData.organizationId,
                userId: userDataForChanges?.[0]?.userId,
                email: userData.email,
                deactivationReason: "DELETED",
              }),
            )

            if (deleteResult?.error) {
              console.log("Error al eliminar el usuario")
            } else {
              console.log("Usuario eliminado exitosamente")
            }
          } else {
            console.log("No se pudo obtener el subscriber_ref_id")
          }
        } catch (error) {
          console.log("Error:", error)
        }
      }

      setuserData({
        ...user,
        status,
      })
    }
  }
  const updateUserStatusLoginAcc = async () => {
    const newStatus = await dispatch(
      updateUserStatusLoginAccount({
        loginAccountId: user.loginAccountId,
        accountStatusCode: selectedStatusLoginAccount,
      }),
    )

    if (newStatus?.accountStatus) {
      const { accountStatusCode, accountStatusDesc } = newStatus.accountStatus

      const accountStatus = {
        accountStatusCode,
        accountStatusDesc,
      }
      setuserData({
        ...user,
        accountStatus,
      })
    }
  }

  const userDataChanges = async () => {
    const datosUsuarios = await getUserOrganizationByLoginAccountCorpEntities(
      user?.loginAccountId,
    )
    setUserDataForChanges(datosUsuarios?.data?.data)
  }

  const handleChangeTypeUser = async () => {
    const status = await dispatch(
      updateUserOrganization({
        organizationUserId: userDataForChanges?.[0]?.userId,
        organizationUserTypeCode: selectedType,
      }),
    )

    if (Number(status?.organizationUserTypeId)) {
      await userDataChanges()
      const getByStatusId = typesUser.find(
        (option) =>
          option.organizationUserTypeId ===
          Number(status.organizationUserTypeId),
      )
      const type = {
        organizationUserTypeCode: getByStatusId.organizationUserTypeCode,
        organizationUserTypeName: getByStatusId.organizationUserTypeName,
      }
      setuserData({
        ...userData,
        type,
      })
    }
  }
  const handleCloseModal = () => {
    setisModalOpenStatusUserOrg(false)
    setisModalOpenStatusAccount(false)
    setisModalOpenTypeUser(false)
  }
  const codeStatesEnabled = ["ACTIVE", "DELETED"]
  const codeTypesEnabled = ["ORG-STAFF", "ORG-ADMIN"]
  const codeStatesAccountEnabled = ["ACTIVE"]

  const filteredTypesOptions = typesUser.filter((option) =>
    codeTypesEnabled.includes(option.organizationUserTypeCode),
  )

  const filteredUserStatus = statesUser.filter((option) =>
    codeStatesAccountEnabled.includes(option.accountStatusCode),
  )

  const filteredUserOrgStatus = statesUserOrg.filter((option) =>
    codeStatesEnabled.includes(option.userStatusCode),
  )
  const getUserStatusLoginAccount = async (email, data) => {
    try {
      const status = await helpGetUserLoginAccountWithEmail(email)

      setuserData({
        ...data,
        accountStatus: status?.data?.loginAccount?.accountStatus,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const loadUserData = async () => {
    setLoading(true)

    await getUserStatusLoginAccount(user.email, user)
    await getUserStatus()
    await getAllTypes()
    await getUserOrgStatus()
    await userDataChanges()
    setLoading(false)
  }
  React.useEffect(() => {
    loadUserData()
  }, [])

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    )
  }
  const UserDetails = ({ user }) => {
    return (
      user && (
        <Grid container className={classes.gridContainer}>
          <Grid container className={classes.gridContainer}>
            <Grid item xs={2} className={classes.boxavatar}>
              <Avatar className={classes.avatar} />
            </Grid>
          </Grid>
          <Grid item xs={10}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                padding: 10,
              }}
            >
              <Grid item xs={5}>
                <Typography className={classes.titles}>
                  Nombre y Apellido:
                </Typography>
                <Typography className={classes.values}>
                  {user.firstName || "- -"} {user.lastName || "- -"}
                </Typography>
              </Grid>

              <Grid item xs={5}>
                <Typography className={classes.titles}>
                  Correo electrónico:
                </Typography>
                <Typography className={classes.values}>
                  {user.email || "- -"}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                padding: 10,
              }}
            >
              <Grid item xs={5}>
                <Typography className={classes.titles}>
                  Fecha de creación:
                </Typography>
                <Typography className={classes.values}>
                  {formatDate(user.accountStatus?.creationDate) || "- -"}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography className={classes.titles}>
                  ID de cuenta de inicio de sesión:
                </Typography>
                <Typography className={classes.values}>
                  {user.loginAccountId || "- -"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ paddingLeft: 9, paddingTop: 10 }}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.titles}>
                Estado de cuenta de Login:
              </Typography>
            </Grid>

            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <FormControl
                variant="outlined"
                style={{ minWidth: 160 }}
                className={classes.value}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={currentUserStatusCode}
                  onChange={(e) =>
                    handleOpenModalChangeStatus(e.target.value, "login_account")
                  }
                >
                  {statesUser.map((item) => {
                    const isActive = item.accountStatusCode === "ACTIVE"
                    return (
                      <MenuItem
                        key={item.accountStatusId}
                        value={item.accountStatusCode}
                        disabled={
                          !(
                            item.accountStatusCode === "ACTIVE" &&
                            userData?.accountStatus?.accountStatusCode ===
                            "WAITING_VALIDATION"
                          )
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          {isActive && (
                            <CheckCircleIcon
                              sx={{ color: "green", fontSize: "20px" }}
                            />
                          )}
                          <Typography sx={isActive ? { color: "green" } : {}}>
                            {item.accountStatusDesc}
                          </Typography>
                        </Box>
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              {isModalOpenTypeUser && (
                <ModalConfirmChange
                  title={"Confirmar cambio de tipo de usuario"}
                  message={"¿Estás seguro de cambiar el tipo del usuario?"}
                  onClose={handleCloseModal}
                  onConfirm={handleChangeTypeUser}
                />
              )}

              {isModalOpenStatusUserOrg && (
                <ModalConfirmChange
                  title="Confirmar cambio de estado"
                  message={`¿Estás seguro de cambiar el estado del usuario?`}
                  onClose={handleCloseModal}
                  onConfirm={handleChangeStatusUser}
                />
              )}
              {isModalOpenStatusAccount && (
                <ModalConfirmChange
                  title="Confirmar cambio de estado"
                  message={`¿Estás seguro de cambiar el estado del usuario?`}
                  onClose={handleCloseModal}
                  onConfirm={updateUserStatusLoginAcc}
                />
              )}
            </Grid>
          </Grid>
          {/* <Grid item xs={10} style={{ paddingLeft: 10, paddingTop: 15 }}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.titles}>
                Tipo de usuario:
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <FormControl
                // variant="outlined"
                style={{ minWidth: 160 }}
                className={classes.value}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={currentUserTypeCode}
                  onChange={(e) => handleOpenModalType(e.target.value)}
                  renderValue={(selected) => {
                    if (!selected)
                      return <span style={{ color: "#aaa" }}>- -</span>
                    const selectedItem = filteredTypesOptions.find(
                      (item) => item.organizationUserTypeCode === selected,
                    )
                    return getTraducTypeUser(selectedItem?.organizationUserTypeCode) || "- -"
                  }}
                >
                  {filteredTypesOptions.map((item) => (
                    <MenuItem
                      key={item.organizationUserTypeId}
                      value={item.organizationUserTypeCode}
                    >
                      {getTraducTypeUser(item.organizationUserTypeCode)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={10} style={{ paddingLeft: 10, paddingTop: 10 }}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.titles}>
                Estado del usuario organización:
              </Typography>
            </Grid>

            <Grid
              item
              xs={8}
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <FormControl
                variant="outlined"
                style={{ minWidth: 160 }}
                className={classes.value}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                    display: "flex",
                    justifyContent: "center",
                  }}
                  value={currentUserOrgStatusCode}
                  onChange={(e) =>
                    handleOpenModalChangeStatus(e.target.value, "user_org")
                  }
                  renderValue={(selected) => {
                    if (!selected)
                      return <span style={{ color: "#aaa" }}>- -</span>
                    const selectedItem = filteredUserOrgStatus.find(
                      (item) => item.userStatusCode === selected,
                    )
                    // return selectedItem?.userStatusName || "- -"
                    if (!selectedItem) return "- -"

                    const isActive = selectedItem.userStatusCode === "ACTIVE"

                    return (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {isActive ? (
                          <CheckCircleIcon
                            sx={{ color: "green", fontSize: "20px" }}
                          />
                        ) : (
                          <CancelIcon sx={{ color: "red", fontSize: "20px" }} />
                        )}
                        <Typography sx={{ color: isActive ? "green" : "red" }}>
                          {selectedItem.userStatusName}
                        </Typography>
                      </Box>
                    )
                  }}
                >
                  {filteredUserOrgStatus.map((item) => {
                    const isActive = item.userStatusCode === "ACTIVE"
                    return (
                      <MenuItem
                        key={item.userStatusId}
                        value={item.userStatusCode}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {isActive ? (
                            <CheckCircleIcon
                              sx={{ color: "green", fontSize: "20px" }}
                            />
                          ) : (
                            <CancelIcon
                              sx={{ color: "red", fontSize: "20px" }}
                            />
                          )}
                          <Typography
                            sx={{ color: isActive ? "green" : "red" }}
                          >
                            {item.userStatusName}
                          </Typography>
                        </Box>
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid> */}
          <Grid container className={classes.gridContainerButtons}>
            <Grid item xs={12}>
              {user.organizationUsers && user.organizationUsers.length > 0 && (
                <div>
                  <NavLink
                    to={`/users/${user.loginAccountId}/subscribers`}
                    className={classes.button}
                  >
                    <PeopleOutlineOutlinedIcon
                      className={classes.iconsButton}
                    />
                    <Typography className={classes.typographyButton}>
                      Ver suscriptores asociados{" "}
                      {"(" + countSubscribersAsociate + ")"}
                    </Typography>
                  </NavLink>
                </div>
              )}

              <div>
                <NavLink
                  to={`/users/${user.loginAccountId}/organizations`}
                  className={classes.button}
                >
                  <BusinessOutlinedIcon className={classes.iconsButton} />
                  <Typography className={classes.typographyButton}>
                    Ver organizaciones asociadas{" "}
                    {"(" + user.organizationUsers.length + ")"}
                  </Typography>
                </NavLink>
              </div>
            </Grid>
          </Grid>
        </Grid>
      )
    )
  }

  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Información del usuario
        </Typography>
        <UserDetails user={user} />
      </div>

      <ButtonClose setStateUserDetails={setStateUserDetails} />
    </>
  )
}

function ButtonClose({ setStateUserDetails }) {
  const classes = useStylesDetails()

  return (
    <Box className={classes.containerbuttonClose}>
      <Box className={classes.buttonClose}>
        <Typography
          onClick={() => {
            setStateUserDetails(false)
          }}
          className={classes.typographyButtonClose}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
